module.exports = __webpack_public_path__ + "static/media/virtual.c66382cc.png";